// Cells for the two Yara Results tables. Every row is a group of yara matches,
// so most cells show a couple of values plus how many more are behind them.
const MAX_DISPLAYED_VALUES = 2;

export const formatYaraTime = (timestamp) => {
  if (!timestamp) return "-";

  try {
    const [ymd, rest] = String(timestamp).split("T");
    const hms = rest.split(".")[0].replace("Z", "");

    return `${ymd} (${hms})`;
  } catch (e) {
    return String(timestamp);
  }
};

export const YaraRuleCell = ({ row }) => {
  const rule = row?.original?.yara_rule || "-";
  const description = row?.original?.rule_description;

  return (
    <div className="yara-results__cell">
      <span className="yara-results__cell__primary">{rule}</span>
      {description ? (
        <span className="yara-results__cell__secondary" title={description}>
          {description}
        </span>
      ) : null}
    </div>
  );
};

export const YaraHostCell = ({ row }) => {
  const hostname = row?.original?.hostname || "-";
  const username = row?.original?.username;
  const localIp = row?.original?.local_ip;
  const secondary = [username, localIp].filter(Boolean).join(" · ");

  return (
    <div className="yara-results__cell">
      <span className="yara-results__cell__primary">{hostname}</span>
      {secondary ? <span className="yara-results__cell__secondary">{secondary}</span> : null}
    </div>
  );
};

// The column accessor is the joined text the exports need, so the chips are read
// from the row itself. `countAccessor` is the real number of unique values; the
// backend only lists the first few of them.
export const createValueListCell = (listAccessor, countAccessor) => {
  const ValueListCell = ({ row }) => {
    const values = row?.original?.[listAccessor] || [];

    if (values.length === 0) return <span>-</span>;

    const total = row?.original?.[countAccessor] || values.length;
    const displayed = values.slice(0, MAX_DISPLAYED_VALUES);
    const hiddenCount = total - displayed.length;

    return (
      <div className="yara-results__chips" title={values.join(", ")}>
        {displayed.map((item) => (
          <span className="yara-results__chips__item" key={item}>
            {item}
          </span>
        ))}
        {hiddenCount > 0 ? (
          <span className="yara-results__chips__more">{`+${hiddenCount}`}</span>
        ) : null}
      </div>
    );
  };

  return ValueListCell;
};

export const MatchCountCell = ({ value }) => (
  <span className="yara-results__count">{value || 0}</span>
);

export const LastSeenCell = ({ value }) => (
  <span style={{ whiteSpace: "nowrap" }}>{formatYaraTime(value)}</span>
);
